module.exports = __webpack_public_path__ + "static/media/pattern_wave--white.bfa07b93.png";